import type { NewsSlide } from "../../const/homeNewsData";

interface NewsBannerProps {
  slides: NewsSlide[];
  activeIndex: number;
  onDotClick: (index: number) => void;
}

function PlaceholderSlide({ slide }: { slide: NewsSlide }) {
  const DecorativeIcon = slide.decorativeIcon;

  return (
    <div
      className="relative w-full h-full p-5 flex flex-col justify-end"
      style={{
        background:
          "linear-gradient(135deg, hsl(226 76% 58%), hsl(218 70% 52%))",
      }}
    >
      {/* Icono decorativo */}
      {DecorativeIcon && (
        <div className="absolute top-2 right-3 opacity-20">
          <DecorativeIcon
            className="h-14 w-14 text-white"
            style={{ transform: "rotate(-20deg)" }}
          />
        </div>
      )}

      {/* Contenido */}
      <div className="relative z-10">
        {slide.title && (
          <h3 className="text-[15px] font-extrabold leading-tight text-white pr-12">
            {slide.title}
          </h3>
        )}
        {slide.bullets && (
          <div className="mt-2 space-y-0.5">
            {slide.bullets.map((bullet, i) => (
              <p key={i} className="text-xs text-white/90 font-medium">
                <span className="mr-1">&bull;</span>
                {bullet}
              </p>
            ))}
          </div>
        )}
        {slide.ctaText && (
          <button
            className="mt-4 px-5 py-1.5 rounded-lg text-xs font-bold text-white transition-opacity hover:opacity-90"
            style={{ background: "hsl(150 70% 45%)" }}
          >
            {slide.ctaText}
          </button>
        )}
      </div>
    </div>
  );
}

export default function NewsBanner({
  slides,
  activeIndex,
  onDotClick,
}: NewsBannerProps) {
  return (
    <div className="px-4">
      {/* Contenedor del carrusel */}
      <div
        className="rounded-xl overflow-hidden relative"
        style={{ aspectRatio: "16 / 9" }}
      >
        {/* Track de slides */}
        <div
          className="flex h-full transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          {slides.map((slide) => (
            <div key={slide.id} className="w-full h-full shrink-0">
              {slide.imageUrl ? (
                <img
                  src={slide.imageUrl}
                  alt={slide.listTitle}
                  className="w-full h-full object-cover"
                />
              ) : (
                <PlaceholderSlide slide={slide} />
              )}
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="absolute bottom-3 left-5 flex gap-1.5">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => onDotClick(i)}
              className={`h-[5px] rounded-full transition-all ${
                i === activeIndex
                  ? "w-5 bg-white"
                  : "w-[5px] bg-white/35"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
